/**
 * Leaf helper for counting traveller types on insurance form occupants.
 * Kept out of insuranceTravellerSchema so insuranceOccupants can use it
 * without the insuranceTravellerSchema ↔ insuranceOccupants cycle.
 */
export function countTravellers(travellers: Array<App.Checkout.TravellerFormSchemaOccupant>) {
  const adults = travellers.filter(traveller => traveller.type === 'adult').length
  const children = travellers.filter(traveller => traveller.type === 'child').length
  const infants = travellers.filter(traveller => traveller.type === 'infant').length

  return {
    adults,
    children,
    infants,
  }
}
